<script setup lang="ts">
import { useGlobalThemeHead } from "./features/cms/data/useGlobalThemeHead";
import { useThemeOptions } from "./features/cms/data/useThemeOptions";

const { locale } = useI18n();

const { data: themeOptions } = await useAsyncData(
  () => `app-theme-options:${locale.value}`,
  () => useThemeOptions(locale.value),
  {
    watch: [locale],
  },
);

useGlobalThemeHead(themeOptions);
</script>

<template>
  <div>
    <NuxtRouteAnnouncer />
<!--     <NuxtLoadingIndicator
      color="linear-gradient(90deg, #7d6b53 0%, #b48c63 45%, #d6c09b 100%)"
      :height="2"
      :throttle="0"
      :duration="2200"
    /> -->
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<style>
body {
  padding: 0;
}
</style>
